document.addEventListener('click', function (event) {

  const requestButton = event.target.closest(
    '#CartDrawer-RequestQuote, .pct-rfq-trigger'
  );

  if (requestButton) {
    openRFQModal();
    return;
  }

  const closeButton = event.target.closest('[data-rfq-close]');

  if (closeButton) {
    closeRFQModal();
  }
});


document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    closeRFQModal();
  }
});


document.addEventListener('submit', function (event) {
  const form = event.target.closest('#PCT-RFQ-Form');

  if (!form) return;

  const name =
    document.getElementById('PCT-RFQ-Name')?.value.trim() || '';

  const company =
    document.getElementById('PCT-RFQ-Company')?.value.trim() || '';

  const email =
    document.getElementById('PCT-RFQ-Email')?.value.trim() || '';

  const phone =
    document.getElementById('PCT-RFQ-Phone')?.value.trim() || '';

  const notes =
    document.getElementById('PCT-RFQ-Customer-Message')?.value.trim() || '';

  const products =
    document.querySelectorAll('#PCT-RFQ-Modal [data-rfq-item]');

  let body = `===================================
REQUEST FOR QUOTE
===================================

CUSTOMER INFORMATION

Name: ${name}
Company: ${company || 'Not provided'}
Email: ${email}
Phone: ${phone || 'Not provided'}

===================================
PRODUCTS REQUESTED
===================================
`;

  products.forEach((product) => {

    const title = product.dataset.product || '';
    const variant = product.dataset.variant || '';
    const sku = product.dataset.sku || '';
    const quantity = product.dataset.quantity || '';
    const price = product.dataset.price || '';

    const requiresQuote =
      product.dataset.requiresQuote === 'true';

    body += `
${title}
--------------------------------------------------
`;

    if (variant && variant !== 'Default Title') {
      body += `Variant: ${variant}\n`;
    }

    body += `SKU: ${sku || 'N/A'}
Quantity: ${quantity}
Status: ${requiresQuote ? 'REQUIRES QUOTE' : `Standard Purchase at ${price}`}

`;

  });

  body += `===================================
ADDITIONAL INFORMATION
===================================

${notes || 'No additional information provided.'}

==============================`;

  const bodyField =
    document.getElementById('PCT-RFQ-Email-Body');

  if (bodyField) {
    bodyField.value = body.trim();
  }
});


function openRFQModal() {

  const modal =
    document.getElementById('PCT-RFQ-Modal');

  if (!modal) return;

  modal.hidden = false;

  document.body.classList.add('pct-rfq-open');

  const firstInput =
    modal.querySelector('input');

  if (firstInput) {
    setTimeout(() => firstInput.focus(), 50);
  }
}


function closeRFQModal() {

  const modal =
    document.getElementById('PCT-RFQ-Modal');

  if (!modal || modal.hidden) return;

  modal.hidden = true;

  document.body.classList.remove('pct-rfq-open');

}